import { FormField } from '@/components/Form/FormField';
import { twMerge } from 'tailwind-merge';

interface FormSectionTitleProps {
  title: string;
  icon?: React.ReactNode;
  containerClassName?: string;
  titleClassName?: string;
}

export const FormSectionTitle = ({
  title,
  icon,
  containerClassName,
  titleClassName,
}: FormSectionTitleProps) => {
  return (
    <FormField
      text=""
      containerClassName={twMerge('mb-2.5', containerClassName)}
    >
      <div className="flex flex-1 items-start gap-3">
        {icon}
        <h3 className={twMerge('font-medium uppercase', titleClassName)}>
          {title}
        </h3>
      </div>
    </FormField>
  );
};
